import React from "react";
import InputTextIcon from "../inputs/input-text-icon";
import Picture from "../image/picture";

class RepIndustryLabel extends React.Component{
    render(){
        var rep=this.props.rep;
        if(!rep) return null;
        return(
            <span className="rep-industry-label">{rep}</span>
        )
    }
}

class RepSearchResults extends React.Component{
    render(){
        var reps=this.props.reps;
        let index=0;
        if(reps.length < 1){
            return(
                <div className="contact-rep-results-container">
                    <div className="contact-rep-results no-results">
                        No Sales Reps found. Please try a different search.
                    </div>
                    <div className="contact-rep-results-back">
                        <button type="submit" onClick={this.props.onSearchReturn} className="ui-button-default ink contact-rep">
                            <img src="/images/icons/arrow-back-2.png" alt="arrow" className="small-arrow-left" />
                            Back to Search
                        </button>
                        <br/><br/><br/>
                    </div>
                </div>
            )
        }
        return(
            <div className="contact-rep-results-container">
                <div className="contact-rep-results">
                    {reps.map((rep) => (
                        <RepCard rep={rep} key={index++} />
                    ))}
                </div>
                <div className="contact-rep-results-back">
                    <button type="submit" onClick={this.props.onSearchReturn} className="ui-button-default ink contact-rep">
                        <img src="/images/icons/arrow-back-2.png" alt="arrow" className="small-arrow-left" />
                        Back to Search
                    </button>
                    <br/><br/><br/>
                </div>

            </div>
            
        )
    }
}

class RepCard extends  React.Component{
    
    render(){
        var rep=this.props.rep;
        let industries=rep.industries;
        let index=0;
        let company=rep.company;
        if(!company) company=rep.name;
        return(
            <div className="contact-rep-card">
                <div className="rep-company">
                    {company}
                </div>
                <div className="rep-industries">
                    <div className="rep-industries-list">
                      {industries.map((ind)=>(
                           <RepIndustryLabel rep={ind} key={index++} />
                     ))}
                     </div>

                </div>
                <div className="card-separator"></div>
                <div className="rep-name" dangerouslySetInnerHTML={{__html: rep.name}}></div>
                {rep.cell && <div className="card-contact-info top">
                    <div className="card-contact-icon"><img className="card-phone-icon" src="/images/icons/phone.svg" alt="Phone" /></div>
                    <div className="card-contact-text">{rep.cell}</div>
                </div>}
                <div className="card-contact-info">
                    <div className="card-contact-icon"><img className="card-email-icon" src="/images/icons/email.svg" alt="Email" /></div>
                    <div className="card-contact-text"><a href={`mailto:${rep.email}`}>{rep.email}</a></div>
                </div>
            </div>
        )

    }

}

class RepSearch extends React.Component{
    render(){
        
        const{image,address,industry,loading, onChangeAddress, onChangeIndustry, onSearchClick}=this.props;
        return(
            <div>
                <div className="contact-rep-inputs-wrapper">
                    <div className="contact-rep-inputs">
                        <InputTextIcon
                            value={address}
                            onChange={onChangeAddress}
                            placeholder="Enter zip code"
                            icon="geo-position.png" 
                            cls="min-width" 
                            required={true}
                        />
                        <select
                            value={industry}
                            onChange={onChangeIndustry} 
                            required={true}
                        >
                            {['Choose an industry', 'Residential', 'Commercial', 'Senior Living'].map((m) => (
                                <option key={m} value={m}>
                                    {m}
                                </option>
                            ))}
                        </select>
                        <button type="submit" onClick={onSearchClick} disabled={loading} className="ui-button-default ink contact-rep">
                            {loading ? "Searching..." : "Search"}
                            <img src="/images/icons/arrow.png" alt="arrow" className="small-arrow-right" />
                        </button>
                    </div>
                </div>
                <div className="contact-rep-image">
                    <Picture src={image} alt="Contact a Rep" />
                    <div className="contact-rep-image-text">
                        Please enter a zipcode and industry to locate your sales representative.
                    </div>
                </div>
            </div>
        );
    }
}

export default class ContactRepComponent extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            address:'',
            industry:'',
            loading:false,
            showResults:false,
            reps:[]
        }
    }

    componentDidMount(){
        this.toast=document.querySelector('paper-toast');
    }

    onChangeAddress=(e)=>{
        this.setState({address:e.target.value});
    }

    onChangeIndustry = (e) => {
        this.setState({ industry: e.target.value });
    }

    onSearchClick=async()=>{
        const{address,industry}=this.state;
        if(!address){
            this.toast.text="Please enter a valid zip code.";
            this.toast.show();
            return;
        }
        if(!industry || industry === 'Choose an industry'){
            this.toast.text="Please select an industry.";
            this.toast.show();
            return;
        }
        this.setState({loading:true});
        await this.fetchAsync(address, industry);
        //await this.mockFetchAsync();
    }

    async fetchAsync(address,industry){
        try {
            let response = await fetch('/api/ContactRep', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ address, industry })
            });
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            let data = await response.json();
            this.setState({ reps: data, showResults: true, loading: false });
        } catch (error) {
            this.toast.text = "An error occurred while searching for representatives. Please try again later.";
            this.toast.show();
            this.setState({ loading: false });
        }
    }

    async mockFetchAsync(){
        return new Promise((resolve)=>{
            setTimeout(()=>{
                const mockReps=[
                    {
                        company:'ABC Supplies',
                        industries:['Residential','Commercial'],
                        cell:'(123) 456-7890',
                        email:'abc@abc.com',
                        name:'John Doe'
                    },
                    {
                        company:'XYZ Solutions',
                        industries:['Senior Living'],
                        cell:'(987) 654-3210',
                        email:'xyz@xyz.com',
                        name:'Jane Smith'
                    },
                    {
                        company: 'XYZ Furniture',
                        industries: ['Residential','Commercial','Senior Living'],
                        cell: '(987) 654-3210',
                        email: 'xyz@xyz.com',
                        name: 'Robert Johnson'
                    },
                    {
                        company: 'Waymar Interiors',
                        industries: ['Senior Living'],
                        cell: '(987) 654-3210',
                        email: 'xyz@xyz.com',
                        name:'&nbsp;'
                    }
                ];
                this.setState({ reps: [], showResults: true, loading: false });
                resolve();
            }, 1000);
        });
    }

    onSearchReturn=()=>{
        this.setState({showResults:false},()=>{
            window.scrollTo(0,0);
        });
    }

    render(){
        const{address,industry,loading,showResults,reps}=this.state;

        return(
            <div className="contact-rep-container">
                {!showResults &&
                    <RepSearch
                        address={address}
                        industry={industry}
                        loading={loading}
                        onChangeAddress={this.onChangeAddress}
                        onChangeIndustry={this.onChangeIndustry} 
                        onSearchClick={this.onSearchClick}
                        image={this.props.image}
                    />
                }
                {showResults &&
                    <RepSearchResults reps={reps} onSearchReturn={this.onSearchReturn} />
                } 
            </div>

        );
    }

}
